
import Professional from "../../../models/Professional";
import FormBase from "../../FormBase";
import FormFieldBase from "../../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../../forms/ValidationBase";
import SupplierDeclarationService from "../../../services/SupplierDeclarationService";

export class SupplierDeclarationItem {
    Id: number;
    SupplierName: string;
    Input: string
    RelationshipSupplier: string;

    constructor(Id: number, SupplierName: string, Input: string, RelationshipSupplier: string) {
        this.Id = Id;
        this.SupplierName = SupplierName;
        this.Input = Input;
        this.RelationshipSupplier = RelationshipSupplier;
    }

    static NewInstance(): SupplierDeclarationItem {
        return new SupplierDeclarationItem(0, "", "", "");
    }
}

export default class SupplierDeclarationForm implements FormBase {
    SupplierName: FormFieldBase;
    Input: FormFieldBase
    RelationshipSupplier: FormFieldBase;

    SupplierDeclarationItemList: SupplierDeclarationItem[];
    SupplierDeclarationItemToEdit: SupplierDeclarationItem;

    constructor() {

        this.SupplierName = new FormFieldBase("", [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.Input = new FormFieldBase("", [new ValidationBase("", ValidationType.OBRIGATORIO)]);
        this.RelationshipSupplier = new FormFieldBase("", [new ValidationBase("", ValidationType.OBRIGATORIO)]);

        this.SupplierDeclarationItemList = new Array<SupplierDeclarationItem>();
        this.SupplierDeclarationItemToEdit = SupplierDeclarationItem.NewInstance();
    }

    static NewInstance(): SupplierDeclarationForm {
        return new SupplierDeclarationForm();
    }

    
    ValidateToGoNextStep(): string {
       return "";
    }

    CallInsertOrUpdateApi(professional: Professional, customAttributes?: any): Promise<any> {
        const dataJson = this.getJsonObjet();
        return SupplierDeclarationService.postInsertOrUpdateSupplierDeclaration(dataJson, professional.Id);
    }

    GetFieldByName(name: string): FormFieldBase {

        switch (name) {

            case "SupplierName":
                return this.SupplierName
            case "Input":
                return this.Input
            case "RelationshipSupplier":
                return this.RelationshipSupplier
            default:
                return new FormFieldBase("", []);
        }
    }

    ResetSupplierForm(): void {
        this.SupplierName.Value = "";
        this.Input.Value = "";
        this.RelationshipSupplier.Value = "";
        this.SupplierDeclarationItemToEdit = SupplierDeclarationItem.NewInstance();
    }

    getNewSupplierId(): number {
        if (this.SupplierDeclarationItemList.length > 0) {
            let maxId = Math.max.apply(Math, this.SupplierDeclarationItemList.map(function (o) { return o.Id; }))
            return maxId + 1;
        } else {
            return 1;
        }
    }

    AddOrUpdateSupplierDeclarationItem() {
        if (this.ValidateSupplierForm()) {

            if (this.SupplierDeclarationItemToEdit === null || this.SupplierDeclarationItemToEdit.Id === 0) {

                let supplierDeclarationItem = new SupplierDeclarationItem(
                    this.getNewSupplierId(),
                    this.SupplierName.Value,
                    this.Input.Value,
                    this.RelationshipSupplier.Value
                )

                this.SupplierDeclarationItemList.push(supplierDeclarationItem);
            } else {
                for (let index = 0; index < this.SupplierDeclarationItemList.length; index++) {
                    const element = this.SupplierDeclarationItemList[index];
                    if (element.Id === this.SupplierDeclarationItemToEdit.Id) {

                        let supplierDeclarationItem = new SupplierDeclarationItem(
                            this.getNewSupplierId(),
                            this.SupplierName.Value,
                            this.Input.Value,
                            this.RelationshipSupplier.Value
                        )

                        this.SupplierDeclarationItemList[index] = supplierDeclarationItem;
                    }
                }
            }
            this.ResetSupplierForm();
        }
    }

    EditSupplierDeclarationItem(id: number) {
        this.ResetSupplierForm();

        for (let index = 0; index < this.SupplierDeclarationItemList.length; index++) {
            const element = this.SupplierDeclarationItemList[index];

            if (element.Id === id) {
                this.SupplierDeclarationItemToEdit = element;

                this.SupplierName.Value = this.SupplierDeclarationItemToEdit.SupplierName;
                this.Input.Value = this.SupplierDeclarationItemToEdit.Input;
                this.RelationshipSupplier.Value = this.SupplierDeclarationItemToEdit.RelationshipSupplier;
            }
        }
    }

    ValidateSupplierForm(): boolean {
        let propNames = ["SupplierName", "Input", "RelationshipSupplier"];

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error  !== null && error  !== "") {
                formIsValid = false;
            }
        }

        return formIsValid

    }

    RemoveSupplierDeclarationItem(id: number) {
        for (let index = 0; index < this.SupplierDeclarationItemList.length; index++) {
            const element = this.SupplierDeclarationItemList[index];
            if (element.Id === id) {
                this.SupplierDeclarationItemList.splice(index, 1);
            }
        }
    }

    getJsonObjet() {

        let viewModelList: any[] = [];

        if (this.SupplierDeclarationItemList != null && this.SupplierDeclarationItemList.length > 0) {
            this.SupplierDeclarationItemList.forEach((element: SupplierDeclarationItem) => {
                viewModelList.push({
                    "supplierName": element.SupplierName,
                    "relationshipSupplier": element.RelationshipSupplier,
                    "input": element.Input,
                  })
            });
        }

        return viewModelList;
    }

}